import React from 'react';
import { Card, CardContent } from '@mui/material';

/**
 * The card a create page's fields sit on. Field wells are tuned to recess against the card;
 * on the page itself (light) they nearly vanish and only the faint outline shows.
 * @param {Object} props
 * @param {React.ReactNode} props.children
 */
export default function FormCard({ children }) {
  return (
    <Card sx={{ mt: 1 }}>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
